import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenShowForRoleDirective } from "./loren-show-for-role-directive/loren-show-for-role.directive";
import { LorenFeatureToggleDirective } from "./loren-feature-toggle-directive/loren-feature-toggle.directive";
import { LorenShowForPrivilegeDirective } from "./loren-show-for-privilege-directive/loren-show-for-privilege.directive";

@NgModule({
  declarations: [
    LorenShowForRoleDirective,
    LorenFeatureToggleDirective,
    LorenShowForPrivilegeDirective,
  ],
  imports: [CommonModule],
  exports: [
    LorenShowForRoleDirective,
    LorenFeatureToggleDirective,
    LorenShowForPrivilegeDirective,
  ],
})
export class LorenSharedDirectivesModule {}
